var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge bg-primary col-sm-2 col-md-2 py-1"},[_vm._v("Total registros: "+_vm._s(_vm.totalRegister))])
}
var staticRenderFns = []

export { render, staticRenderFns }